import { PDF_COLORS, PDF_LINE_HEIGHT, pdfFz, seccionHeadingV2, PDF_LABEL_FONT } from "./stylesPDFv2";

/**
 * Renderiza una lista de pares etiqueta/valor como filas apiladas.

 * @param {Array<{label:string,value:any,strong?:boolean}|null|false>} rows
 * @param {object} opts
 * @param {string|number} opts.labelWidth ancho de la columna etiqueta
 * @returns Array de nodos pdfMake (columns)
 */
export const kvRows = (rows = [], { labelWidth = "38%", fontSize, columnGap = 8, rowMargin = 1.5 } = {}) =>
  (rows || []).filter(Boolean).map((r) => {
    const baseFontSize = fontSize != null ? fontSize : pdfFz(7);
    const baseLineHeight = PDF_LINE_HEIGHT;

    const labelCell = {
      width: labelWidth,
      text: r.label,
      font: PDF_LABEL_FONT, // bold:true resuelve a Mulish-Bold (700): etiqueta en negritas
      fontSize: baseFontSize,
      lineHeight: baseLineHeight,
      color: PDF_COLORS.label,
      bold: true, // etiquetas siempre en negritas; el valor queda en peso regular
    };

    let valueCell;
    if (typeof r.value === "object" && r.value !== null) {
      valueCell = {
        width: "*",
        fontSize: baseFontSize,
        lineHeight: baseLineHeight,
        ...r.value,
      };
    } else {
      valueCell = {
        width: "*",
        text: r.value ?? "",
        fontSize: baseFontSize,
        lineHeight: baseLineHeight,
        color: PDF_COLORS.ink,
        bold: !!r.strong,
      };
    }

    return {
      columns: [labelCell, valueCell],
      columnGap,
      margin: [0, rowMargin, 0, rowMargin],
    };
  });

/** Título de sección (delega en el encabezado del tema). */
export const tituloSeccionV2 = (texto) => seccionHeadingV2(texto);

export default kvRows;